// src/pages/Authentication/UserProfile/debug.ts
// Debug helper để kiểm tra structure của authUser trong localStorage

export const debugAuthUser = () => {
  console.group('🔍 DEBUG: AuthUser Structure');
  
  const authUserStr = localStorage.getItem('authUser');
  
  if (!authUserStr) {
    console.error('❌ Không tìm thấy authUser trong localStorage');
    console.groupEnd();
    return null;
  }
  
  try {
    const authUser = JSON.parse(authUserStr);
    
    console.log('📦 Raw authUser object:', authUser);
    console.log('');
    
    // Kiểm tra các fields chính
    console.group('✅ Main Fields:');
    console.log('uid:', authUser.uid);
    console.log('username:', authUser.username);
    console.log('email:', authUser.email);
    console.log('role:', authUser.role);
    console.log('avatar:', authUser.avatar);
    console.groupEnd();
    
    // Kiểm tra nested data object
    if (authUser.data) {
      console.group('📋 Nested Data Object:');
      console.log('data.email:', authUser.data.email);
      console.log('data.first_name:', authUser.data.first_name);
      console.log('data.phone:', authUser.data.phone);
      console.log('data.idCard:', authUser.data.idCard);
      console.log('data.dateOfBirth:', authUser.data.dateOfBirth);
      console.log('data.address:', authUser.data.address);
      console.log('data.avatar:', authUser.data.avatar);
      console.log('data.department:', authUser.data.department);
      console.log('data.position:', authUser.data.position);
      console.log('data.role:', authUser.data.role);
      console.log('data.lastModifiedAt:', authUser.data.lastModifiedAt);
      console.groupEnd();
    } else {
      console.warn('⚠️ Không có nested data object');
    }
    
    // Mapping preview cho mock profile
    console.group('🗺️ Mapping Preview (sẽ dùng cho mock profile):');
    const mockProfile = {
      id: authUser.uid || '1',
      email: authUser.email || authUser.data?.email || 'N/A',
      name: authUser.username || authUser.data?.first_name || 'N/A',
      phoneNumber: authUser.data?.phone || 'N/A',
      idCard: authUser.data?.idCard || 'N/A',
      dateOfBirth: authUser.data?.dateOfBirth || 'N/A',
      address: authUser.data?.address || 'N/A',
      avatar: authUser.avatar || authUser.data?.avatar || '',
      departmentName: authUser.data?.department || 'N/A',
      position: authUser.data?.position || 'N/A',
      roleName: authUser.role || authUser.data?.role || 'N/A',
      lastModifiedAt: authUser.data?.lastModifiedAt || 'N/A',
      status: 'active'
    };
    console.table(mockProfile);
    console.groupEnd();
    
    // Kiểm tra các fields bị thiếu
    console.group('⚠️ Missing Fields Check:');
    const missingFields = [];
    if (!authUser.data?.phone) missingFields.push('phone');
    if (!authUser.data?.idCard) missingFields.push('idCard');
    if (!authUser.data?.dateOfBirth) missingFields.push('dateOfBirth');
    if (!authUser.data?.address) missingFields.push('address');
    if (!authUser.data?.department) missingFields.push('department');
    if (!authUser.data?.position) missingFields.push('position');
    
    if (missingFields.length > 0) {
      console.warn('Các fields bị thiếu:', missingFields.join(', '));
    } else {
      console.log('✅ Tất cả fields đều có dữ liệu');
    }
    console.groupEnd();
    
    console.groupEnd();
    return authUser;
    
  } catch (error) {
    console.error('❌ Lỗi khi parse authUser:', error);
    console.groupEnd();
    return null;
  }
};

// Export để có thể gọi từ browser console: window.debugAuthUser()
if (typeof window !== 'undefined') {
  (window as any).debugAuthUser = debugAuthUser;
}
